import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';

// services
import { AuthService, NavigationService } from '@sideline/sideline-apps-shared';

export const authErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const navService = inject(NavigationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return from(authService.refreshToken()).pipe(
          switchMap((refreshed) => {
            if (refreshed) {
              const retryReq = req.clone({
                setHeaders: { Authorization: `Bearer ${authService.getToken()}` },
              });
              return next(retryReq);
            }
            navService.signOut();
            return throwError(() => error);
          }),
        );
      }

      if (error.status === 403) {
        navService.notAuthorized();
      }

      return throwError(() => error);
    }),
  );
};
